import { render, staticRenderFns } from "./ConversationPage.vue?vue&type=template&id=25c2b6a6"
import script from "./ConversationPage.vue?vue&type=script&lang=js"
export * from "./ConversationPage.vue?vue&type=script&lang=js"
import style0 from "./ConversationPage.vue?vue&type=style&index=0&id=25c2b6a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports